module.exports = __webpack_public_path__ + "img/raw2.063e6821.png";